import type { ArtFormInput } from "web_myplann/Portfolio/Forms/ArtForm/artFormSchema";

export const artFormDefaultValues: ArtFormInput = {
	propertyType: "",
	customDisposition: "",
	purchaseDate: null,
	description: "",
	value: null,
	forInvestments: false,
};
